export const createMeta = vm => ({
  title: vm.$t('result.seo.title', { orderId: vm.mealCode, storeName: vm.storeInfo?.name }),
  meta: {
    pageTitle: { name: 'Page Title', content: vm.$t('result.seo.pageTitle', { orderId: vm.mealCode, storeName: vm.storeInfo?.name }), },
  },
})
